import { all } from 'redux-saga/effects';

function* LayoutSaga() {
    yield all([
    ]);
}

export default LayoutSaga;
